import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import cn from 'classnames';

import SupportBlocks from './SupportBlocks';
import LinkBack from '../widgets/LinkBack';
import Typography from '../widgets/Typography/Typography';
import BlockFiles from '../widgets/Typography/BlockFiles';
import BlockInfo from '../widgets/Typography/BlockInfo';
import BlockLink from '../widgets/Typography/BlockLink';
import BlockImage from '../widgets/Typography/BlockImage';
import BlockPrograms from '../widgets/Typography/BlockPrograms';

import './support.scss';

class SupportTemplate extends PureComponent {
  render() {
    return (
      <div className={cn('support', this.props.name)}>
        {(this.props.page.meta) &&
          <Helmet>
            <title>{this.props.page.meta.title}</title>
          </Helmet>
        }

        <div className="container">
          <div className="support-content">
            <LinkBack link="/support/subnavigation/">
              Сопровождаем <i>вернуться</i>
            </LinkBack>

            <Typography content={this.props.page.content} />

            <BlockPrograms content={this.props.page.programs} />
          </div>

          <div className="support-panel">
            {(!!this.props.page.blocks) &&
              <SupportBlocks content={this.props.page.blocks}/>
            }

            {(!!this.props.page.image) &&
              <BlockImage content={this.props.page.image} />
            }
            {(!!this.props.page.info) &&
              <BlockInfo content={this.props.page.info} />
            }

            {(!!this.props.page.link) &&
              <BlockLink content={this.props.page.link} />
            }
            {(!!this.props.page.files) &&
              <BlockFiles content={this.props.page.files}/>
            }
          </div>
        </div>
      </div>
    );
  }
}

SupportTemplate.propTypes = {
  name: PropTypes.string,
  page: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object),
    blocks: PropTypes.arrayOf(PropTypes.object),
    info: PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string
    }),
    link: PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.string,
      label: PropTypes.string
    }),
    meta: PropTypes.shape({
      title: PropTypes.string
    })
  }),
  subnavigationOpen: PropTypes.func
};

export default SupportTemplate;



// WEBPACK FOOTER //
// ./src/components/Support/SupportTemplate.js